import createIcon from '../../createIcon';

/**
 * @component @name RequestPage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMkg2QzQuOSAyIDQgMi45IDQgNFYyMEM0IDIxLjEgNC45IDIyIDYgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjhMMTQgMlpNMTUgMTFIMTFWMTJIMTRDMTQuNTUgMTIgMTUgMTIuNDUgMTUgMTNWMTZDMTUgMTYuNTUgMTQuNTUgMTcgMTQgMTdIMTNWMThIMTFWMTdIOVYxNUgxM1YxNEgxMEM5LjQ1IDE0IDkgMTMuNTUgOSAxM1YxMEM5IDkuNDUgOS40NSA5IDEwIDlIMTFWOEgxM1Y5SDE1VjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RequestPage = createIcon('RequestPage', [
  [
    'path',
    {
      d: 'M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM15 11H11V12H14C14.55 12 15 12.45 15 13V16C15 16.55 14.55 17 14 17H13V18H11V17H9V15H13V14H10C9.45 14 9 13.55 9 13V10C9 9.45 9.45 9 10 9H11V8H13V9H15V11Z',
      key: '1m1b1a',
    },
  ],
]);

export default RequestPage;
